import React from "react";
import SongCard from "./SongCard";
import { isZh } from "../utils/language";

export default function SongsContent({
  rows,
  loading,
  mode,
  selectedPlaylist,
  setSelectedPlaylist,
  play,
  playingId,
  canEdit,
  setEditingData,
  setShowDialog,
  setFileSong,
  setShareData,
  setEditingPlaylist
}) {
  if (loading) return <div className="empty">Loading...</div>;
  if (!rows.length) return <div className="empty">Belum ada lagu yang sesuai. Periksa pencarian atau filter Anda.</div>;

  // ================= ALBUM LIST =================
  if (mode === "album" && !selectedPlaylist) {
    return rows.map(p => (
      <div
        key={p.id}
        className="content-row"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center"
        }}
      >
        <div
          style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
          onClick={() => setSelectedPlaylist(p)}
        >
          📚
          <div style={{ marginLeft: 10 }}>
            <div style={{ fontWeight: 700 }}>{p.title_zh}</div>
            <div style={{ fontSize: "0.875rem" }}>{p.title_id}</div>
            <div style={{ fontSize: "0.75rem", color: "#999" }}>
              {isZh()
                ? `共 ${(p.song_playlist_items || []).length} 首`
                : `Isi: ${(p.song_playlist_items || []).length} lagu`}
            </div>
          </div>
        </div>

        {canEdit && (
          <button
            className="btn-secondary"
            onClick={() => {
              setEditingPlaylist(p);
              setShowDialog("album");
            }}
          >
            ✏️
          </button>
        )}
      </div>
    ));
  }

  // ================= SONG LIST =================
  return rows.map(s => (
    <SongCard
      key={s.id}
      song={s}
      onPlay={play}
      isPlaying={playingId === s.id}
      onEdit={
        canEdit
          ? (song) => {
              setEditingData(song);
              setShowDialog("song");
            }
          : null
      }
      onManageFiles={(song) => setFileSong(song)}
      onShare={
        canEdit ? (song) => setShareData({ type: "song", song }) : null
      }
      mode={mode}
    />
  ));
}